
		import async from 'preact-cli/async-component';

		function load(cb) {
			require.ensure([], function(require) {
				cb(require("!!../../../node_modules/babel-loader/lib/index.js??ref--0!./index.js"));
			}, "route-team");
		}

		export default async(load);
	


//////////////////
// WEBPACK FOOTER
// ./routes/team/index.js
// module id = Z9l3
// module chunks = 12